import React from "react"
import { useRecoilState } from "recoil"
import { makeStyles } from "@material-ui/core/styles"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"

import Button from "../components/Button"
import onboardingProgress from "../store/onboardingProgress"

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  button: {
    marginRight: theme.spacing(3),
  },
}))

export default function StepButtons({
  disableNext = false,
  isLoading = false,
  nextText,
  removeBack = false,
}) {
  const classes = useStyles()
  const [progress, setProgress] = useRecoilState(onboardingProgress)

  const handleBack = () => {
    setProgress({
      ...progress,
      activeStep: progress.activeStep - 1,
    })
  }

  const handleNext = () => {
    // setProgress({
    //   ...progress,
    //   activeStep: progress.activeStep + 1,
    // })
  }

  return (
    <div className={classes.root}>
      {!removeBack ? (
        <Button
          className={classes.button}
          disabled={progress.activeStep === 0 || isLoading}
          onClick={handleBack}
          size="small"
        >
          Back
        </Button>
      ) : (
        ""
      )}
      <Button
        onClick={handleNext}
        color="primary"
        disabled={disableNext}
        endIcon={<ChevronRightIcon />}
        isLoading={isLoading}
        size="small"
        // style={{ backgroundColor: "#009599" }}
        type="submit"
      >
        {nextText || "Next"}
      </Button>
    </div>
  )
}
